<template>
  <div v-if="needLogin" class="user-oneid-login-btn" @click="onUserOneIDLogInBtnClick">
    Log In
  </div>
  <div v-else class="user-oneid-login-btn userNameCircle">
    <el-dropdown trigger="click" @command="handleLogOut()" placement="bottom">
      <span class="el-dropdown-link nameStyle">
        {{ msgText.toUpperCase() || '' }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>Log Out</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import Vue from "vue";
import { getTokenValidate } from '@/api/userOneID'
const { USERONEID_BASE_URL } = process.env;
const APPCODE = "dataexpo";

export default {
  data() {
    return {
      token: '',
      msgText: "Log In",
      needLogin: true // 用户是否需要登录
    };
  },
  mounted() {
    // 从localStorage中获取accessToken和userName，如果没有取到，间隔3s后再次执行
    let token = localStorage.getItem('accessToken') || null
    this.token = token
    let userName = localStorage.getItem('userName') || null
    if (token !== null && userName !== null) {
      let words = userName.split(' ') // 将字符串按空格分割成数组
      let lastWord = words[words.length - 1] // 获取数组中的最后一个单词
      this.msgText = lastWord.slice(0,1); // 获取最后一个单词的首字母
      this.needLogin = false
    } else {
      setTimeout(() => {
        let token = localStorage.getItem('accessToken') || null
        let userName = localStorage.getItem('userName') || null
        if (token !== null && userName !== null) {
          let words = userName.split(' ') // 将字符串按空格分割成数组
          let lastWord = words[words.length - 1] // 获取数组中的最后一个单词
          this.msgText = lastWord.slice(0,1); // 获取最后一个单词的首字母
          this.needLogin = false
        } else {
          this.msgText = 'Log In'
          this.needLogin = true
        }
      }, 3000);
    }
    this.PollingUserStatus()
  },
  methods: {
    onUserOneIDLogInBtnClick() {
      const context = {
        name: this.$route.name,
        fromAcemap: false,
      };
      const UserOneIDLogInURL = `${USERONEID_BASE_URL}/v1/sdk/login/sso?appCode=${APPCODE}&context=${encodeURI(
        JSON.stringify(context)
      )}`;
      window.open(UserOneIDLogInURL, "_blank");
    },
    onUserOneIDLogOutBtnClick() {
      const context = encodeURIComponent('https://dataexpo.acemap.info/#/');
      const UserOneIDLogOutURL = `${USERONEID_BASE_URL}/cas/logout?context=${context}`;
      this.resetStatus()
      window.open(UserOneIDLogOutURL, "_blank");
    },
    handleLogOut() {
      this.$confirm('Please confirm whether to exit?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // this.$message({
          //   type: 'success',
          //   message: 'Success!'
          // });
          this.onUserOneIDLogOutBtnClick()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled'
          });      
        });
    },
    // 轮询用户登陆状态是否失效
    PollingUserStatus() {
      if (!this.token) {
        return;
      }
      this.getTokenValidate();
      setInterval(() => {
        this.getTokenValidate();
      }, 300000);
    },
    getTokenValidate() {
      getTokenValidate(this.token).then((res) => {
        const status = res.data.data.data;
        // 状态失效
        if (status) {
          this.resetStatus();
        }
      });
    },
    resetStatus() {
      this.needLogin = true
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userName");
    }
  },
};
</script>
  <style lang="less" scoped>
* {
  font-family: ddefont;
}
.user-oneid-login-btn {
  border-radius: 4px;
  // width: 75px;
  height: 30px;
  // background: rgba(255, 255, 255, 0.4);
  background: #f25b28;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(20px);
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  padding: 0px 24px;
  cursor: pointer;
}
.nameStyle {
  color: #fff;
  font-weight: bold;
}
.userNameCircle {
  border-radius: 50% !important;
  display: flex;
  justify-content: center;
  align-content: center;
}
.el-dropdown {
  font-size: 18px !important;
}
</style>
  